export default __webpack_public_path__ + "static/binance-1eb9244bb9ace483c824bc0f777ffa7a.svg";